import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { isNullOrUndefined } from 'util';
import { ActivatedRoute, NavigationEnd, Router, RouterEvent } from '@angular/router';
import { filter } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';



@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {
  static readonly ROUTE_DATA_BREADCRUMB = 'label';
  readonly home = { icon: 'pi pi-home', url: '#/home' };
  public menuItems: any[] = [];
  public test = 'Any';

  constructor(private router: Router, private activatedRoute: ActivatedRoute, private translate: TranslateService) {
    this.watchRouteChanges();
    translate.use('en');
  }

  private createBreadcrumbs(route: ActivatedRoute, url: string = '#', breadcrumbs: MenuItem[] = []): MenuItem[] {

    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      let routeURL: string;
      routeURL = child.snapshot.url.map(segment => segment.path).join('/');

      if (routeURL !== '') {
        url += `/${routeURL}`;
      }

      let label = child.snapshot.data[BreadcrumbComponent.ROUTE_DATA_BREADCRUMB] ? child.snapshot.data[BreadcrumbComponent.ROUTE_DATA_BREADCRUMB] : child.snapshot.routeConfig.path;
      this.translate.get(label.toUpperCase()).subscribe(l => {
        if (!isNullOrUndefined(label)) {
          breadcrumbs.push({ label: l, url });
        }
      })

      return this.createBreadcrumbs(child, url, breadcrumbs);
    }
  }

  watchRouteChanges() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.menuItems = this.createBreadcrumbs(this.activatedRoute.root);
      });
  }

  ngOnInit() {



  }
}
